const state = {
  menuControl: {
    width: 'w-8',
    opacity: '0'
  },
  activeMenu: null,
  activeSubMenu: null
}

const getters = {
  menuControl: (state) => state.menuControl,
  activeMenu: (state) => state.activeMenu,
  activeSubMenu: (state) => state.activeSubMenu
}

const actions = {
  toActiveMenu: ({ state, dispatch }, menu) => {
    if (menu.name !== 'Disable') {
      if (state.activeMenu === menu.name) {
        if (!menu.force) {
          state.activeMenu = null

          dispatch('toHideMenu')
        }
      } else {
        state.activeMenu = menu.name

        if (menu.large) {
          dispatch('toShowLargeMenu')
        } else {
          dispatch('toShowMenu')
        }
      }
    } else if (state.activeMenu === 'Disable') {
      state.activeMenu = null
    } else {
      state.activeMenu = 'Disable'

      dispatch('toHideMenu')
    }
  },
  toShowMenu: ({ commit }) => {
    commit('setMenuControl', {
      width: 'w-full sm:w-80',
      opacity: '95'
    })
  },
  toHideMenu: ({ commit }) => {
    commit('setMenuControl', {
      width: 'w-8',
      opacity: '0'
    })
  },
  toShowLargeMenu: ({ commit }) => {
    commit('setMenuControl', {
      width: 'w-full sm:w-9/12',
      opacity: '95'
    })
  }
}

const mutations = {
  setMenuControl: (state, menuControl) => {
    state.menuControl = { ...state.menuControl, ...menuControl }
  },
  setActiveSubMenu: (state, activeSubMenu) => state.activeSubMenu = activeSubMenu
}

export default {
  state,
  getters,
  actions,
  mutations
}
